import type { StorageClient } from "@phurshell/psiapp-frontend-core/domain";

export class PiniaStorageClient<T> implements StorageClient<T> {
  constructor(private readonly getStore: () => any) {}

  save(_key: string, value: T): void {
    const store = this.getStore();
    if (store?.save) store.save(value);
  }

  get(key: string): T | null {
    const store = this.getStore();
    return store?.[key] ?? null;
  }

  update(_key: string, value: Partial<T>): void {
    const store = this.getStore();
    if (store?.update) store.update(value);
  }

  remove(_key: string): void {
    const store = this.getStore();
    if (store?.destroy) store.destroy();
  }
}
